import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import ScrollContainer from 'react-indiana-drag-scroll';
import { dateFormat } from '../../helpers/stringFormat.js';
import { getDaysOfWeek, durations, weekTitles } from '../../helpers/getWeekDays';
import { getCookie, MAX_WEEKS, useDimensions } from '../../helpers/globals';
import { DRAG_GENERAL_BACKGROUND, DRAG_DROP_BACKGROUND } from '../../helpers/globals';
import { FilledBrightButton } from '@oneblinktech-org/helios-base'
import { plus } from '../../fakeData/svgFiles.js'
import { Skeleton } from 'antd';
import ExpandedCard from '../../components/modals/ExpandedCard';
import {
    debouncedGetPlanningJobs,
    debouncedScheduleJobs,
    debouncedGetColorList,
    debouncedGetVehicleMakes,
    debouncedGetChooseJob,
    resetOpenJob,
    setIsNewJob,
    debouncedGetJobVehicleImgs,
    getAllAssignableUsers
} from '../../store/job/actions'
import {
    debouncedUpdateCounterData,
    getNoteList
} from '../../store/note/actions'
import { useDocumentTitle } from '../../components/useDocumentTitle';
import Card from '../../components/dragAndDrop/card';
import { initializePusher, unbindPusher } from '../../pusherManager.js';
import TitleWithSelection from '../../components/TitleWithSelection.js';
import SetDefaultPage from '../../components/SetDefaultPage.js';
import Loader from '../../components/Loader.js';
import { PERMISSIONS } from "../../constants/permissions";
import { usePageHeader } from '../../context/HeaderContext.js';

const LAST_WEEK = -1;
const SUNDAY = 0;
const SATURDAY = 6;

const onDragEnd = (props, result, columns, setColumns, setIsPusherEvent) => {

    const { source, destination, draggableId } = result;
    if (
        !destination ||
        (destination.droppableId === source.droppableId &&
          destination.index === source.index)
      ) {
        return;
    }

    let chooseDay = columns[destination.droppableId]['date']

    if (source.droppableId !== destination.droppableId) {
        const sourceColumn = columns[source.droppableId];
        const destColumn = columns[destination.droppableId];
        const sourceItems = [...sourceColumn.jobs];
        const destItems = [...destColumn.jobs];
        const [removed] = sourceItems.splice(source.index, 1);
        destItems.splice(destination.index, 0, removed);

        let payload = {
            chooseDay: chooseDay,
            jobs: destItems.map(a => a.id)
        }

        props.debouncedScheduleJobs(payload)

        // setIsPusherEvent(true)
        setColumns({
            ...columns,
            [source.droppableId]: {
                ...sourceColumn,
                jobs: sourceItems
            },
            [destination.droppableId]: {
                ...destColumn,
                jobs: destItems
            }
        });
    } else {
        const column = columns[source.droppableId];
        const copiedItems = [...column.jobs];
        const [removed] = copiedItems.splice(source.index, 1);
        copiedItems.splice(destination.index, 0, removed);

        setColumns({
            ...columns,
            [source.droppableId]: {
                ...column,
                jobs: copiedItems
            }
        });
    }
};

const PlanningBoard = (props) => {

    useDocumentTitle("Helios - Planning Board")

    const [columns, setColumns] = useState({})
    const [skeleton, SetSkeleton] = useState(true)
    const [selectedJob, setSelectedJob] = useState({});
    const elementRefs = useRef([])
    const initialRender = useRef(true);
    const [isCardChanged, setIsCardChanged] = useState(false);
    const [isPusherEvent, setIsPusherEvent] = useState(false);
    const [columnHeights, setColumnHeights] = useState([200, 200, 200, 200, 200])
    const [archivedJob, setArchivedJob] = useState(false);
    const [pulseAnimation, setPulseAnimation] = useState(false)
    const [isDragging, setIsDragging] = useState(false)
    const [activeDistance, setActiveDistance] = useState(5)

    const orgId = getCookie('active_organization_id')

    const { permissions } = useSelector((state) => state.PermissionReducer);
    const canCreateJob = permissions.includes(PERMISSIONS.JOB_CREATE);
    const canSeeJobCustomerName = permissions.includes(PERMISSIONS.JOB_CUSTOMER_NAME_VIEW);
    const canUpdateJobDot = permissions.includes(PERMISSIONS.JOB_CARD_DOT_UPDATE);


    useEffect(() => {
        initializePusher("product-board", "job-event", (data) => {
            if (data.event === "card changed" && data?.orgId?.toString() === orgId?.toString()) {
                getPlanningSchedules(false);

                if (data?.value && selectedJob) {
                    if (selectedJob?.id === data.value) {
                        props.debouncedGetChooseJob(data.value, false);
                        props.getNoteList(data.value, localStorage.getItem('showDetail') ?? true);
                        setIsCardChanged(true);
                    }
                }
            }
            if (data.event === "job file changed" && data?.orgId?.toString() === orgId?.toString()) {
                if (data?.value && selectedJob && (data.value === selectedJob?.id)) {
                    props.debouncedGetJobVehicleImgs(data?.value);
                }
            }
        });

        initializePusher("organizations", "choose-event", (data) => {
            if (data?.orgId?.toString() === orgId?.toString()) {
                getPlanningSchedules(false);
            }
            if (data.event === "selected" && data?.orgId) {
                getPlanningSchedules(true);
                setColumns({})
            }
        })

        initializePusher("planning-board", "move-event", (data) => {
            if (data.event === "planning scheduled" && !isPusherEvent && data?.orgId?.toString() === orgId?.toString()) {
                getPlanningSchedules(false);
            }
            setIsPusherEvent(false);
        })
        return () => {
            unbindPusher("product-board", "job-event");
            unbindPusher("organizations", "choose-event");
            unbindPusher("planning-board", "move-event");
        }
    }, [isPusherEvent, orgId, props, selectedJob])

    useEffect(() => {
        if (props?.colorList?.data?.length === 0)
            props.debouncedGetColorList()

        let isMounted = true
        if(isMounted) {
            if (Object.keys(props.jobs).length > 0) {
                setColumns(props.jobs)
            }
        }
        return () => {
            isMounted = false
        }

    }, [props.jobs])

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" });
        getPlanningSchedules(true)
        props.getAllAssignableUsers()
        if(!props?.vehicleMakes?.data || Object.values(props?.vehicleMakes?.data)?.length===0)
            props.debouncedGetVehicleMakes()
    }, [])

    useEffect(() => {
        props.debouncedUpdateCounterData((columns[MAX_WEEKS]?.jobs)?.length)
    }, [columns[MAX_WEEKS]])

    useEffect(() => {
        if (props.loading && Object.keys(columns)?.length === 0) {
            SetSkeleton(true)
        } else {
            SetSkeleton(false)
        }
    }, [props.loading])

    useEffect(() => {
        if (props.isNewJob)
            setSelectedJob(null)
    }, [props?.isNewJob])

    const getPlanningSchedules = (isLoading) => {
        let days = getDaysOfWeek(LAST_WEEK, MAX_WEEKS)
        let dayDuration = {
            startDay: days[0],
            endDay: days[MAX_WEEKS - 1]
        }

        props.debouncedGetPlanningJobs(dayDuration, isLoading)
    }

    const onToggleCard = (open, columnId, itemId) => {
        let oldJobs = (columns[columnId])['jobs']
        let updatedjobs = oldJobs.map(obj => {
            if (obj.id == itemId) {
                return {...obj, open: open ? 0 : 1}
            }
            return obj
        })

        setColumns({
            ...columns,
            [columnId]: {
                ...columns[columnId],
                jobs: updatedjobs
            }
        })
    }

    const changeBackground = (color) => {
        setSelectedJob({...selectedJob, color_id: color?.id, job_color: color})
    }

    useEffect(() => {
        const init = () => {
            setTimeout(() => {
                const li = document.querySelectorAll('.calendar_box:nth-child(7n+1)')
                let heights = []
                li.forEach(itm => {
                    var style = window.getComputedStyle(itm)
                    var exactHeight = parseFloat(style.height);
                    heights.push( Number(parseFloat(exactHeight).toFixed(2)))
                })
                setColumnHeights(heights)
            }, 200)
        }
        init()
    }, [columns])

    const onDragUpdate = (e) => {
        setTimeout(() => {
            const li = document.querySelectorAll('.calendar_box:nth-child(7n+1)')
            let heights = []
            li.forEach(itm => {
                var style = window.getComputedStyle(itm)
                var exactHeight = parseFloat(style.height);
                heights.push( Number(parseFloat(exactHeight).toFixed(2)))
            })
            setColumnHeights(heights)
        }, 200)
    }

    const onArchiveJob = (status) => {
        // status - 0: archive, 1: unarchive
        if(status == 0) {
            setArchivedJob(true)
        }else if(status == 1) {
            setPulseAnimation(false)
            setArchivedJob(false)
            setTimeout(() => {
                setPulseAnimation(false)
            }, 5000)
        }
    }

    usePageHeader(
        <div className="page-header-container">
            <TitleWithSelection title='Planning Board'>
                <SetDefaultPage routeName='/planning' checked={localStorage.getItem('defaultLandingPage') === '/planning'} />
            </TitleWithSelection>
            {canCreateJob && (
                <div className="action">
                    <div id={`job_new`} className='job-item contents' >
                        <div className="btn-small"
                            onClick={(e) => {
                                if (Object?.keys(props?.newJob?.data)?.length > 0)
                                    props.resetOpenJob()
                                props.setIsNewJob(true)
                                setSelectedJob(null)
                            }}
                        >
                            <span dangerouslySetInnerHTML={{ __html: plus }} />
                            <span>New Job</span>
                        </div>
                    </div>
                </div>
            )}
        </div>,
        [props?.newJob?.data]
    )

    return (
        <div className="planning-board">
            <Loader loading={props.loading && Object.keys(columns)?.length === 0} />
            <DragDropContext
                onBeforeDragStart={() => setActiveDistance(2000)}
                onDragStart={() => setActiveDistance(2000)}
                onDragUpdate={(e)=> onDragUpdate(e)}
                onDragEnd={result => {
                    setActiveDistance(5)
                    onDragEnd(props, result, columns, setColumns, setIsPusherEvent)
                }}
            >
                <div className="d-flex flex-row board-wrap">
                    <div className="d-flex flex-column justify-content-start pending">
                        <div className="d-flex flex-row justify-content-between align-items-center p-1 px-2 header">
                            <h6 className="mb-0">Unscheduled Jobs</h6>
                            <div className='count-badge'>
                                <small className='column-title'>{Object.keys(columns).length > 0 ? columns[MAX_WEEKS].jobs.length : 0}</small>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "start"
                            }}
                            className='scroll-block'
                        >
                            {/* columns of 56 are unscheduled jobs */}
                            <div style={{ margin: 8, width: '100%', height: '98%' }}>
                                {
                                    skeleton ?
                                    <Skeleton active />
                                    :
                                    Object.keys(columns).length > 0 &&
                                    <Droppable droppableId={String(MAX_WEEKS)} key={String(MAX_WEEKS)}>
                                    {(provided, snapshot) => {
                                        return (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className={snapshot.isdraggingover? 'active-color':'pannel'}
                                            style={{
                                                padding: 4,
                                                minHeight: 500,
                                                height: "100%"
                                            }}
                                        >
                                            {columns[MAX_WEEKS].jobs.map((item, index) => {
                                            return (
                                                <Draggable
                                                key={item.id}
                                                draggableId={(item.id).toString()}
                                                index={index}
                                                >
                                                {(provided, snapshot) => {
                                                    return (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className='drag_drop-card'
                                                        onClick={() => {
                                                            setSelectedJob(item)
                                                            window.dispatchEvent(new CustomEvent('jobCardQuickOpen', { detail: item }))
                                                            props.setIsNewJob(false)
                                                            props.debouncedGetChooseJob(item.id, true)
                                                        }}
                                                    >
                                                        <Card data={item} colorList={props.colorList} canSeeJobCustomerName={canSeeJobCustomerName} canUpdateJobDot={canUpdateJobDot} />
                                                    </div>
                                                    );
                                                }}
                                                </Draggable>
                                            );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                        );
                                    }}
                                    </Droppable>
                                }
                            </div>
                        </div>
                    </div>
                    <ScrollContainer
                        className='w-100 remove-overflow'
                        ignoreElements=".drag_drop-card, *[prevent-drag-scroll]"
                        hideScrollbars={false}
                        activationDistance={activeDistance}
                        stopPropagation={true}
                        onScroll={() => { }}
                    >
                        <div className="calendar-container d-flex flex-row">
                            <div className="d-flex flex-column leftside">
                                {
                                    durations.length > 0 &&
                                    durations.map((duration, key) =>
                                        <div key={`${key}_${columnHeights?.length > 0 ? columnHeights[key] : 0}`} className="duration-item" style={{ minHeight: columnHeights?.length > 0 ? columnHeights[key] : 225 }} >
                                            <div className="wrap d-flex flex-column">
                                                <span>{duration.text}</span>
                                                <small className="d-flex flex-row align-items-center">
                                                    {dateFormat(getDaysOfWeek(duration.key, 7)[SUNDAY], 'DUR_DATE')}
                                                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.40823 10.0851H19.121L13.8011 15.1371C13.533 15.3917 13.3824 15.737 13.3824 16.097C13.3824 16.4571 13.533 16.8024 13.8011 17.057C14.0691 17.3115 14.4326 17.4545 14.8116 17.4545C15.1906 17.4545 15.5541 17.3115 15.8221 17.057L23.5818 9.68689C24.1394 9.15644 24.1394 8.29722 23.5818 7.76677L15.8221 0.3976C15.5429 0.132433 15.1776 0 14.8114 0C14.4452 0 14.0794 0.132131 13.8008 0.397298C13.5327 0.651842 13.3821 0.997147 13.3821 1.35721C13.3821 1.71727 13.5327 2.06257 13.8008 2.31712L19.121 7.36977H1.40823C0.627113 7.38083 0 7.98542 0 8.72743C0 9.46944 0.627113 10.074 1.40823 10.0851Z" />
                                                    </svg>
                                                    {dateFormat(getDaysOfWeek(duration.key, 7)[SATURDAY], 'DUR_DATE')}
                                                </small>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>

                            <ol className="calendar">
                                {
                                    weekTitles.length > 0 &&
                                    weekTitles.map((title, key) =>
                                        <li key={key} className="calendar-day calendar-day--begin-week calendar-day--past calendar-day--not-month week-day px-3 py-2">{title}</li>
                                    )
                                }
                                {skeleton ?
                                <Skeleton active />:
                                    Object.keys(columns).length > 0 &&
                                    Object?.entries(columns).filter(([ci, c], i) => ci != MAX_WEEKS && ci != (MAX_WEEKS + 1)).map(([columnId, column], index) =>
                                        <li ref={(element) => elementRefs.current[index] = element} key={index} className={ 'ref_' + index + " calendar_box calendar-day calendar-day--begin-week calendar-day--past calendar-day--not-month"}>
                                            <Droppable droppableId={columnId.toString()} key={columnId.toString()}>
                                                {(provided, snapshot) => {
                                                    return (
                                                        <div
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}
                                                            style={{
                                                                padding: 4,
                                                                minHeight: 225,
                                                                height: "100%",
                                                                width: "100%"
                                                            }}
                                                            className={`${snapshot.isdraggingover? 'active-color':'pannel'} p-2 d-flex flex-column justify-content-start`}
                                                        >
                                                            {
                                                                skeleton ?
                                                                    <Skeleton active />
                                                                    :
                                                                    column.jobs.map((item, index) =>
                                                                        <Draggable
                                                                            key={item.id.toString()}
                                                                            draggableId={item.id.toString()}
                                                                            index={index}
                                                                        >
                                                                            {(provided, snapshot) => {
                                                                                return (
                                                                                    <div
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                        className='drag_drop-card'
                                                                                        onClick={() => {
                                                                                            setSelectedJob(item)
                                                                                            window.dispatchEvent(new CustomEvent('jobCardQuickOpen', { detail: item }))
                                                                                            props.setIsNewJob(false)
                                                                                            props.debouncedGetChooseJob(item.id, true)
                                                                                        }}
                                                                                    >
                                                                                        <Card data={item} colorList={props.colorList} canSeeJobCustomerName={canSeeJobCustomerName} canUpdateJobDot={canUpdateJobDot} />
                                                                                    </div>
                                                                                );
                                                                            }}
                                                                        </Draggable>
                                                                    )}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                }
                                            </Droppable>
                                        </li>
                                    )
                                }
                        </ol>
                        </div>
                    </ScrollContainer>
                    <div className="d-flex flex-column justify-content-start pending checkin">
                        <div className="d-flex flex-row justify-content-between align-items-center p-1 header">
                            <h6 className="mb-0">Check-in</h6>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "start"
                            }}
                            className='scroll-block'
                        >
                            {/* columns of 57 are checkin jobs */}
                            <div style={{ margin: 6, width: '100%', height: '98%' }}>
                                {
                                    skeleton ?
                                    <Skeleton active />
                                    :
                                    Object.keys(columns).length > 0 &&
                                    <Droppable droppableId={(MAX_WEEKS + 1)?.toString()} key={(MAX_WEEKS + 1)?.toString()}>
                                    {(provided, snapshot) => {
                                        return (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className={snapshot.isdraggingover? 'active-color':'pannel'}
                                            style={{
                                                padding: 2,
                                                minHeight: 500,
                                                height: "100%"
                                            }}
                                        >
                                            {columns[(MAX_WEEKS+1)].jobs.map((item, index) => {
                                            return (
                                                <Draggable
                                                key={item.id}
                                                draggableId={(item.id).toString()}
                                                index={index}
                                                >
                                                {(provided, snapshot) => {
                                                    return (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className='drag_drop-card'
                                                        onClick={() => {
                                                            setSelectedJob(item)
                                                            window.dispatchEvent(new CustomEvent('jobCardQuickOpen', { detail: item }))
                                                            props.setIsNewJob(false)
                                                            props.debouncedGetChooseJob(item.id, true)
                                                        }}
                                                    >
                                                        <Card data={item} colorList={props.colorList} canSeeJobCustomerName={canSeeJobCustomerName} canUpdateJobDot={canUpdateJobDot} />
                                                    </div>
                                                    );
                                                }}
                                                </Draggable>
                                            );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                        );
                                    }}
                                    </Droppable>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </DragDropContext>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        jobs: state.JobReducer.planningJobs.data,
        colorList: state.JobReducer.colorList,
        loading: state.JobReducer.planningJobs.loading,
        vehicleMakes: state.JobReducer.vehicleMakes,
        newJob: state.JobReducer.newJob,
        isNewJob: state.JobReducer.isNewJob
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        debouncedGetPlanningJobs: (dayDuration, isLoading) => debouncedGetPlanningJobs(dispatch, dayDuration, isLoading),
        debouncedScheduleJobs: (data) => debouncedScheduleJobs(dispatch, data),
        debouncedGetColorList: () => debouncedGetColorList(dispatch),
        debouncedUpdateCounterData: (count) => debouncedUpdateCounterData(dispatch, count),
        debouncedGetVehicleMakes: () => debouncedGetVehicleMakes(dispatch),
        debouncedGetChooseJob: (id, loading) => debouncedGetChooseJob(dispatch, id, loading),
        resetOpenJob: () => dispatch(resetOpenJob()),
        getNoteList: (jobId, isLog) => dispatch(getNoteList(jobId, isLog)),
        setIsNewJob: (isNew) => dispatch(setIsNewJob(isNew)),
        debouncedGetJobVehicleImgs: (id) => debouncedGetJobVehicleImgs(dispatch, id),
        getAllAssignableUsers: () => dispatch(getAllAssignableUsers()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoard)
